import React, { useEffect, useState } from "react";
import { getCustomerMessageList, recipientSendMessage } from "../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../utils";
import io from "socket.io-client";
import {SOCKET_URL} from "../../../src/configs/AppConfig";


const socket = io(SOCKET_URL, {
    transports: ['websocket'],
    secure: true,
    rejectUnauthorized: false,
});

const Messages = (props) => {
    const [recipientName, setRecipientName] = useState("");
    const [messageList, setMessageList] = useState([]);
    const [message, setMessage] = useState("");
    let errorsObj = { message: "" };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        if (props?.envelopeData?.id) {
            setRecipientName(
                props?.envelopeData?.recipient_detail.first_name +
                " " +
                props?.envelopeData?.recipient_detail.last_name
            );

            let obj = {
                from_id: props?.envelopeData?.recipient_detail?.id,
                to_id: props?.envelopeData?.sender_id,
                entity_type: 1,
                entity_id: props?.envelopeData?.id,
            };
            getCustomerMessageList(obj)
                .then((response) => {
                    setMessageList(response.data.data);
                })
                .catch((err) => {
                    console.error("Error fetching messages:", err);
                });

            socket.emit("joinRoom", {
                entity_id: props.envelopeData.id,
                user_id: props.envelopeData.recipient_detail.id,
            });

            socket.on("receiveMessage", (msg) => {
                setMessageList((prev) => [...prev, {
                    ...msg,
                    sender_name: msg.sender_name || recipientName,
                }]);
            });
        }

        return () => {
            socket.off("receiveMessage");
        };
    }, [props.envelopeData, recipientName]);

    const HandleClick = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (!message.trim()) {
            errorObj.message = "Message must be required";
            error = true;
        } else if (message.length > 5000) {
            errorObj.message = "Message length should be 5000 or smaller only";
            error = true;
        }

        setErrors(errorObj);
        if (error) return;

        if (props?.envelopeData?.id) {
            let obj = {
                from_id: props?.envelopeData?.recipient_detail?.id,
                to_id: props?.envelopeData?.sender_id,
                entity_type: 1,
                entity_id: props?.envelopeData?.id,
                table_type: 2,
                message: message.trim(),
                sender_name: recipientName,
            };

            setMessage("");
            socket.emit("sendMessage", obj);

            recipientSendMessage(obj)
                .then((response) => {
                    toast.success(response.data.message);
                })
                .catch((err) => {
                    toast.error(Utils.getErrorMessage(err));
                });
        }
    };

    const handleSendMessage = (e) => {
        if (e.key === "Enter") {
            HandleClick(e);
        }
    };

    return (
        <div className="tab-pane fade p-4 message_accordion" id="messages" role="tabpanel" aria-labelledby="messages-tab">
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseMessage"
                            aria-expanded="true"
                            aria-controls="collapseMessage"
                        >
                            <i className="bi bi-chat-fill me-2" aria-hidden="true" />
                            Message with{" "}
                            {props?.envelopeData?.contact_detail?.first_name +
                                " " +
                                props?.envelopeData?.contact_detail?.last_name}
                        </button>
                    </h2>
                    <div
                        id="collapseMessage"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                    >
                        <div className="accordion-body chat_box">
                            {messageList &&
                                messageList.map((messages, index) => (
                                    <div
                                        key={index}
                                        className={`${props?.envelopeData?.recipient_detail?.id === messages.created_by
                                                ? `chat_message_left green_bg`
                                                : `chat_message_right`
                                            } chat_message card`}
                                    >
                                        <h6>{messages.sender_name}</h6>
                                        <p dangerouslySetInnerHTML={{ __html: messages.message }} />
                                        <div className="d-flex messages_timing">
                                            <span className="me-2">
                                                {/* <i className="bi bi-calendar" aria-hidden="true" />  */}
                                                {messages.date}
                                            </span>
                                            <span>
                                                {/* <i className="bi bi-clock-fill" aria-hidden="true" /> */}
                                                 {messages.time}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            <div className="mt-4 mb-2 d-flex align-items-center">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Message.."
                                    onKeyDown={handleSendMessage}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                                <i
                                    className="bi bi-arrow-right black_bg"
                                    aria-hidden="true"
                                    role="button"
                                    onClick={HandleClick}
                                />
                            </div>
                            {errors.message && (
                                <div className="text-danger form-text">{errors.message}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Messages;